import clsx from "clsx";
import { ChangeEvent, FC, useEffect, useState } from "react";
import { PulseLoader } from "react-spinners";
import { ArrowSmallDownIcon } from "../../../assets";
import {
  Button,
  CheckBox,
  PageItem,
  RequestItem,
  SearchInput,
} from "../../../components";
import { IRequest } from "../../../models";
import { getRequests } from "../../../services/request.service";
import styles from "./styles.module.scss";

const limit = 20;

const NewRequests: FC = (): JSX.Element => {
  const [activeTab, setActiveTab] = useState<"Candidate" | "Employer">(
    "Candidate"
  );
  const [search, setSearch] = useState<string>("");
  const [page, setPage] = useState<number>(1);
  const [pagesCount, setPagesCount] = useState<number>(0);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [request, setRequest] = useState<IRequest[]>([]);
  const [sort, setSort] = useState<number>(-1);

  const onChangeSearch = (e: ChangeEvent<HTMLInputElement>) => {
    setSearch(e.target.value);
  };

  const onGetRequests = async (
    page: number = 1,
    limit: number,
    search: string = ""
  ) => {
    try {
      setIsLoading(true);

      const { data } = await getRequests(page, limit, search, sort, activeTab);
      if (data?.success) {
        setPagesCount(Math.ceil(data?.count / limit));
        setRequest(data?.videos);
        setPage(page);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    let timeout = setTimeout(() => {
      if (search) {
        onGetRequests(1, limit, search);
      }
    }, 400);

    return () => clearTimeout(timeout);
  }, [search, sort, activeTab]);

  useEffect(() => {
    if (!search) {
      onGetRequests(1, limit, search);
    }
  }, [search, sort, activeTab]);

  return (
    <>
      <div className={styles.wrapper}>
        <header className={styles.header}>
          <h4 className={styles.title}>New Requests</h4>
        </header>
        <section className={styles.contentContainer}>
          <div className={styles.sortSwitchersWrapper}>
            <Button
              title={"Companies"}
              size={"x-small"}
              onClick={() => setActiveTab("Employer")}
              styleType={activeTab == "Employer" ? "filled" : "inactive"}
            />
            <Button
              title={"Candidates"}
              size={"x-small"}
              onClick={() => setActiveTab("Candidate")}
              styleType={activeTab == "Candidate" ? "filled" : "inactive"}
            />
          </div>
          <div className={styles.searchContainer}>
            <SearchInput
              placeholder="Search"
              value={search}
              onChange={onChangeSearch}
            />
          </div>
          <div className={styles.sectionHeader}>
            <CheckBox isChecked={false} setIsChecked={() => {}} />
            <div className={styles.reporterBlock}>
              <p>Reporter</p> <ArrowSmallDownIcon />
            </div>
            <div className={styles.tagsBlock}>
              <p>Tags</p> <ArrowSmallDownIcon />
            </div>

            <div
              onClick={() => setSort((prev) => (prev === 1 ? -1 : 1))}
              className={clsx(styles.dateBlock, {
                [styles.dateBlockActive]: sort === 1,
              })}
            >
              <p>Request date</p> <ArrowSmallDownIcon />
            </div>
          </div>
          <div className={styles.reportsContainer}>
            {isLoading && (
              <div className={styles.loaderWrapper}>
                <PulseLoader color={"#7D4AFB"} />
              </div>
            )}
            {!isLoading &&
              request.map((item, index) => {
                return (
                  <RequestItem
                    onGetRequests={onGetRequests}
                    item={item}
                    key={item.id}
                    type={activeTab}
                  />
                );
              })}
            {!isLoading && request?.length === 0 && (
              <div className={styles.emptyTitle}>There are no new requests</div>
            )}
          </div>
        </section>
      </div>
    </>
  );
};

export default NewRequests;
